/**
 * @generated SignedSource<<8e7740e302a10b4e8cc86af524c9a198>>
 * @relayHash 8c2d6bc12a43a64350298b9d0ab04658
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e5f064e7b1891b93df75b8466e159e4c098252e386af020bd8f3d67cd06e9dcc

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalPanelQuery$variables = {
  ari: string;
  queryContext?: string | null | undefined;
};
export type GoalPanelQuery$data = {
  readonly goals_byId: {
    readonly id: string;
    readonly key: string;
    readonly url: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"GoalActions" | "GoalCustomFields" | "GoalFocusAreas" | "GoalFollowers" | "GoalMetrics" | "GoalOwner" | "GoalPanelTitleField" | "GoalStartDate" | "GoalStatusField" | "GoalTags" | "GoalTargetDate" | "GoalTeams" | "GoalType" | "GoalUpdateComposerCreate" | "ParentGoal" | "SubGoals">;
  };
  readonly me: {
    readonly user: {
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"GoalPanelTabs">;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "queryContext"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = [
  {
    "kind": "Variable",
    "name": "goalId",
    "variableName": "ari"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v11 = {
  "kind": "ScalarField",
  "name": "canRemoveLinkedGoals"
},
v12 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v13 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v14 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v15 = [
  (v5/*: any*/),
  (v1/*: any*/)
],
v16 = [
  (v1/*: any*/)
],
v17 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v18 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "value"
},
v20 = [
  (v19/*: any*/)
],
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v22 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v20/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v21/*: any*/)
  ]
},
v23 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ]
},
v24 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v20/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v21/*: any*/)
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "kind"
},
v26 = {
  "kind": "ScalarField",
  "name": "score"
},
v27 = [
  (v19/*: any*/),
  (v26/*: any*/)
],
v28 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v27/*: any*/)
},
v29 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v30 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v31 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v32 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v31/*: any*/)
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v34 = {
  "kind": "ScalarField",
  "name": "type"
},
v35 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/)
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "subType"
},
v37 = {
  "kind": "ScalarField",
  "name": "archived"
},
v38 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v39 = {
  "kind": "ScalarField",
  "name": "source"
},
v40 = {
  "kind": "ScalarField",
  "name": "time"
},
v41 = [
  (v40/*: any*/),
  (v1/*: any*/)
],
v42 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v41/*: any*/)
},
v43 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v44 = [
  (v43/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_ASC"
    ]
  }
],
v45 = {
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v27/*: any*/)
},
v46 = {
  "kind": "ScalarField",
  "name": "start"
},
v47 = {
  "concreteType": "TownsquareMetric",
  "kind": "LinkedField",
  "name": "metric",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v34/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/),
    (v42/*: any*/),
    {
      "args": (v44/*: any*/),
      "concreteType": "TownsquareMetricValueConnection",
      "kind": "LinkedField",
      "name": "values",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareMetricValueEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TownsquareMetricValue",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v40/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "origin",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "TownsquareGoalUpdate",
                          "kind": "LinkedField",
                          "name": "goalUpdate",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "TownsquareGoal",
                              "kind": "LinkedField",
                              "name": "goal",
                              "plural": false,
                              "selections": (v16/*: any*/)
                            },
                            (v45/*: any*/),
                            (v1/*: any*/)
                          ]
                        }
                      ],
                      "type": "TownsquareFromGoalUpdate"
                    }
                  ]
                },
                (v1/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "args": (v44/*: any*/),
          "concreteType": "TownsquareMetricValueConnection_extension",
          "kind": "LinkedField",
          "name": "values_extension",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareMetricValueEdge_extension",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareMetricValue",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v41/*: any*/)
                },
                {
                  "concreteType": "TownsquareMetricTargetPeriod_extension",
                  "kind": "LinkedField",
                  "name": "metricTargetPeriod",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareTargetDate",
                      "kind": "LinkedField",
                      "name": "time",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "TownsquareTargetDateRange",
                          "kind": "LinkedField",
                          "name": "dateRange",
                          "plural": false,
                          "selections": [
                            (v46/*: any*/)
                          ]
                        }
                      ]
                    },
                    (v19/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "variance"
                }
              ]
            }
          ],
          "storageKey": "values_extension(first:100,sort:[\"TIME_ASC\"])"
        }
      ]
    }
  ]
},
v48 = [
  (v19/*: any*/),
  (v1/*: any*/)
],
v49 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v48/*: any*/)
},
v50 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v51 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v52 = {
  "concreteType": "TownsquareGoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v1/*: any*/),
    (v23/*: any*/)
  ]
},
v53 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v34/*: any*/),
                (v36/*: any*/),
                (v37/*: any*/),
                (v38/*: any*/),
                (v39/*: any*/),
                (v42/*: any*/)
              ]
            },
            (v49/*: any*/),
            (v50/*: any*/),
            (v51/*: any*/)
          ]
        }
      ]
    }
  ]
},
v54 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v55 = [
  (v54/*: any*/)
],
v56 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": (v55/*: any*/)
},
v57 = [
  (v9/*: any*/),
  (v31/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v1/*: any*/)
],
v58 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v57/*: any*/)
},
v59 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v60 = {
  "kind": "ScalarField",
  "name": "label"
},
v61 = {
  "kind": "ScalarField",
  "name": "summary"
},
v62 = {
  "kind": "ScalarField",
  "name": "description"
},
v63 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v64 = [
  (v9/*: any*/),
  (v3/*: any*/),
  (v2/*: any*/),
  (v31/*: any*/),
  (v1/*: any*/)
],
v65 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v64/*: any*/)
},
v66 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v64/*: any*/)
},
v67 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v68 = [
  (v59/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v19/*: any*/),
      (v26/*: any*/),
      (v60/*: any*/)
    ]
  },
  (v61/*: any*/),
  {
    "kind": "LinkedField",
    "name": "creator",
    "plural": false,
    "selections": (v57/*: any*/)
  },
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v37/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v1/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v59/*: any*/),
              (v67/*: any*/)
            ]
          }
        ]
      },
      (v18/*: any*/)
    ]
  },
  (v1/*: any*/)
],
v69 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v68/*: any*/)
},
v70 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v71 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v72 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v73 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v70/*: any*/),
          (v71/*: any*/),
          (v61/*: any*/),
          (v72/*: any*/),
          (v59/*: any*/),
          (v1/*: any*/)
        ]
      }
    ]
  }
],
v74 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 30
    }
  ],
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": (v73/*: any*/),
  "storageKey": "updates(first:30)"
},
v75 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v76 = [
  (v75/*: any*/),
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v77 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v78 = {
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v20/*: any*/)
},
v79 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v55/*: any*/)
},
v80 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v81 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v82 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v83 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v81/*: any*/),
    (v82/*: any*/)
  ]
},
v84 = {
  "args": (v76/*: any*/),
  "filters": [
    "tql"
  ],
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
},
v85 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v86 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v33/*: any*/)
  ]
},
v87 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v88 = {
  "args": (v87/*: any*/),
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": (v73/*: any*/),
  "storageKey": "updates(first:10)"
},
v89 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v62/*: any*/)
],
v90 = [
  (v43/*: any*/)
],
v91 = [
  (v60/*: any*/),
  (v54/*: any*/)
],
v92 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v2/*: any*/),
                (v1/*: any*/),
                (v31/*: any*/),
                (v3/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v72/*: any*/),
            (v59/*: any*/)
          ]
        }
      ]
    },
    (v18/*: any*/)
  ]
},
v93 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v61/*: any*/),
      (v62/*: any*/),
      (v65/*: any*/),
      (v66/*: any*/),
      (v59/*: any*/),
      (v67/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v94 = [
  (v75/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v4/*: any*/),
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "goals_byId",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            {
              "args": (v8/*: any*/),
              "kind": "FragmentSpread",
              "name": "GoalFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalPanelTitleField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalType"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalMetrics"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ParentGoal"
            },
            {
              "kind": "FragmentSpread",
              "name": "SubGoals"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalActions"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTeams"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalCustomFields"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalUpdateComposerCreate"
            }
          ]
        },
        "action": "THROW",
        "path": "goals_byId"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
          },
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalPanelTabs"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byId",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedFocusAreas"
              },
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareFocusAppCapabilities",
                    "kind": "LinkedField",
                    "name": "focus",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canViewFocusAreas"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              },
              {
                "kind": "ScalarField",
                "name": "canManageOwnership"
              },
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              (v11/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddTags"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTags"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStartDate"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveGoal"
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canDeleteGoal"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canAddTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canEditCustomFields"
              },
              (v12/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canEditUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedProjects"
              },
              (v13/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canAddJiraAlignItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveJiraAlignItems"
              }
            ]
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v2/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v15/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v15/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoalIcon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "appearance"
              }
            ]
          },
          (v2/*: any*/),
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v1/*: any*/),
              (v23/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v1/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/)
                ]
              },
              (v25/*: any*/)
            ]
          },
          (v28/*: any*/),
          (v29/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          (v30/*: any*/),
          (v32/*: any*/),
          (v35/*: any*/),
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v47/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      (v1/*: any*/),
                      (v52/*: any*/),
                      (v30/*: any*/),
                      (v53/*: any*/),
                      (v6/*: any*/),
                      (v28/*: any*/),
                      (v2/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      (v37/*: any*/),
                      (v29/*: any*/),
                      (v56/*: any*/),
                      (v58/*: any*/),
                      (v69/*: any*/),
                      (v74/*: any*/),
                      {
                        "args": (v76/*: any*/),
                        "concreteType": "TownsquareProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  (v77/*: any*/),
                                  (v78/*: any*/),
                                  (v79/*: any*/),
                                  (v32/*: any*/),
                                  (v9/*: any*/)
                                ]
                              },
                              (v80/*: any*/),
                              (v9/*: any*/)
                            ]
                          },
                          (v83/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      },
                      (v84/*: any*/)
                    ]
                  }
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "args": (v85/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v86/*: any*/),
                      (v37/*: any*/),
                      (v1/*: any*/),
                      (v30/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          (v24/*: any*/),
                          (v1/*: any*/),
                          (v23/*: any*/)
                        ]
                      },
                      (v2/*: any*/),
                      (v28/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v47/*: any*/),
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v51/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v6/*: any*/),
                      (v29/*: any*/),
                      (v56/*: any*/),
                      (v58/*: any*/),
                      (v69/*: any*/),
                      (v14/*: any*/),
                      (v88/*: any*/),
                      (v5/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "targetDate",
            "plural": false,
            "selections": [
              (v54/*: any*/),
              {
                "kind": "ScalarField",
                "name": "confidence"
              }
            ]
          },
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v1/*: any*/),
              (v35/*: any*/),
              (v53/*: any*/),
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": (v20/*: any*/)
              },
              (v2/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v1/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v11/*: any*/)
                ]
              },
              (v14/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v62/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v82/*: any*/),
                  (v81/*: any*/)
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareSlackConnectionConnection",
            "kind": "LinkedField",
            "name": "slackChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareSlackConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareSlackConnection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareSlackChannel",
                        "kind": "LinkedField",
                        "name": "channel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "numMembers"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareMsteamsConnectedChannelConnection",
            "kind": "LinkedField",
            "name": "msteamsChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMsteamsConnectedChannelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMsteamsConnectedChannelInfo",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          (v59/*: any*/),
          {
            "concreteType": "TownsquareGoalTeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalTeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemove"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      }
                    ]
                  }
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v89/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v17/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v18/*: any*/)
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v89/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v17/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v18/*: any*/)
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v89/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v17/*: any*/)
                            ]
                          },
                          {
                            "args": (v90/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v1/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isUser"
                                      },
                                      (v2/*: any*/),
                                      (v3/*: any*/)
                                    ]
                                  },
                                  (v80/*: any*/)
                                ]
                              },
                              (v83/*: any*/),
                              (v18/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v90/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v18/*: any*/)
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v62/*: any*/),
                                  {
                                    "args": (v90/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v1/*: any*/),
                                              (v19/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v17/*: any*/)
                            ]
                          },
                          {
                            "args": (v90/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v9/*: any*/)
                                    ]
                                  },
                                  (v80/*: any*/)
                                ]
                              },
                              (v83/*: any*/),
                              (v18/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v90/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v18/*: any*/)
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v37/*: any*/),
          {
            "args": (v87/*: any*/),
            "concreteType": "TownsquareGoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v61/*: any*/),
                      {
                        "concreteType": "TownsquareUpdateNoteConnection",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUpdateNoteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v1/*: any*/),
                                  (v37/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v59/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v1/*: any*/),
                          (v31/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v91/*: any*/)
                      },
                      (v45/*: any*/),
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v48/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v2/*: any*/),
                                      (v34/*: any*/),
                                      (v36/*: any*/),
                                      (v37/*: any*/),
                                      (v39/*: any*/),
                                      (v42/*: any*/),
                                      {
                                        "args": [
                                          (v43/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": [
                                              "TIME_DESC"
                                            ]
                                          }
                                        ],
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v19/*: any*/),
                                                  (v40/*: any*/),
                                                  (v1/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v48/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "args": (v85/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v33/*: any*/)
                                    ]
                                  },
                                  (v1/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v68/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "nodeMissingReason"
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v86/*: any*/),
                                  (v53/*: any*/),
                                  (v6/*: any*/),
                                  (v29/*: any*/),
                                  (v56/*: any*/),
                                  (v58/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v31/*: any*/),
                          (v2/*: any*/),
                          (v1/*: any*/)
                        ]
                      },
                      (v72/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v1/*: any*/),
                                      (v2/*: any*/),
                                      (v31/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v9/*: any*/),
                                  (v1/*: any*/),
                                  (v63/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/),
                                  (v59/*: any*/),
                                  (v67/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v18/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v29/*: any*/),
                          (v37/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/),
                                  (v24/*: any*/),
                                  (v1/*: any*/)
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/)
                            ]
                          },
                          {
                            "args": (v85/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v2/*: any*/),
                                      (v37/*: any*/),
                                      (v35/*: any*/),
                                      (v53/*: any*/),
                                      (v6/*: any*/),
                                      (v29/*: any*/),
                                      (v56/*: any*/),
                                      (v58/*: any*/),
                                      (v69/*: any*/),
                                      (v14/*: any*/),
                                      (v30/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v24/*: any*/),
                                          (v23/*: any*/),
                                          (v1/*: any*/)
                                        ]
                                      },
                                      (v28/*: any*/),
                                      (v88/*: any*/)
                                    ]
                                  },
                                  (v9/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "successMeasures(first:50)"
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v2/*: any*/),
                                      (v37/*: any*/),
                                      (v35/*: any*/),
                                      (v52/*: any*/),
                                      (v53/*: any*/),
                                      (v6/*: any*/),
                                      (v29/*: any*/),
                                      (v56/*: any*/),
                                      (v58/*: any*/),
                                      (v69/*: any*/),
                                      (v30/*: any*/),
                                      (v28/*: any*/),
                                      (v74/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": (v87/*: any*/),
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v61/*: any*/),
                                      {
                                        "concreteType": "TownsquareUpdateNoteConnection",
                                        "kind": "LinkedField",
                                        "name": "updateNotes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNote",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v61/*: any*/),
                                                  (v62/*: any*/),
                                                  (v1/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          },
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v1/*: any*/),
                                          (v37/*: any*/)
                                        ]
                                      },
                                      (v1/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      (v92/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v27/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v91/*: any*/)
                      }
                    ]
                  }
                ]
              },
              (v18/*: any*/)
            ],
            "storageKey": "updates(first:10)"
          },
          (v62/*: any*/),
          (v92/*: any*/),
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "args": (v76/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v80/*: any*/),
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      (v78/*: any*/),
                      (v32/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      (v77/*: any*/),
                      (v79/*: any*/)
                    ]
                  }
                ]
              },
              (v83/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": "projects(first:200,tql:\"archived = false\")"
          },
          (v84/*: any*/),
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v93/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v93/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v93/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "args": (v94/*: any*/),
            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "workItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v5/*: any*/),
                          (v61/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "webUrl"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v80/*: any*/),
                  (v1/*: any*/)
                ]
              },
              (v83/*: any*/),
              (v18/*: any*/)
            ]
          },
          {
            "args": (v94/*: any*/),
            "filters": [
              "queryContext"
            ],
            "handle": "connection",
            "key": "GoalContentJira_workItems",
            "kind": "LinkedHandle",
            "name": "workItems"
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectUrl"
                          }
                        ],
                        "type": "JiraAlignAggProject"
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v1/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "updateStreak_extension"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e5f064e7b1891b93df75b8466e159e4c098252e386af020bd8f3d67cd06e9dcc",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "aff0ec12cadf172d9b6264d6e43003ad";

export default node;
